import { alpha } from '@material-ui/core/styles/colorManipulator';

export default (theme) => ({
  chip: {
    display: 'inline-flex',
    alignItems: 'center',
    padding: '4px 6px',
    background: alpha(theme.palette.primary.main, 0.18),
    borderRadius: 4,
    cursor: 'pointer',
    color: theme.palette.primary.main,
    fontSize: 13,
    lineHeight: '22px',
    maxWidth: '100%',
    '&:hover': {
      background: alpha(theme.palette.primary.main, 0.28),
    },
  },
  chipStatic: {
    cursor: 'default',
    '&:hover': {
      background: alpha(theme.palette.primary.main, 0.18),
    },
  },
  chipSelected: {
    background: theme.palette.primary.main,
    color: theme.palette.textColor.white,
    '&:hover': {
      background: theme.palette.primary.main,
    },
    '& $removeIcon': {
      color: theme.palette.textColor.white,
    },
  },
  chipDisabled: {
    cursor: 'default',
    opacity: 0.6,
    '&:hover': {
      background: alpha(theme.palette.primary.main, 0.18),
    },
  },
  chipLabel: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  chipBadge: {
    marginLeft: 4,
    opacity: 0.75,
    fontStyle: 'italic',
  },
  removeIcon: {
    padding: 0,
    marginLeft: 4,
    color: theme.palette.primary.main,
  },
});
